import { useEffect, useState, useCallback } from 'react'
import { apiUrl } from '../lib/api'

export interface LiveObservation {
  id: string
  content: string
  agent_id: string
  category: string
  confidence: number
  timestamp: string
}

interface LiveStreamResponse {
  observations: LiveObservation[]
  count: number
  generated_at: string
}

interface UseLiveStreamOptions {
  limit?: number
  pollInterval?: number
}

export function useLiveStream(options: UseLiveStreamOptions = {}) {
  const { limit = 20, pollInterval = 10000 } = options
  const [observations, setObservations] = useState<LiveObservation[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchObservations = useCallback(async () => {
    try {
      const response = await fetch(apiUrl(`/api/observations?limit=${limit}`))
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data: LiveStreamResponse = await response.json()
      setObservations(data.observations)
      setError(null)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch observations')
    } finally {
      setLoading(false)
    }
  }, [limit])

  useEffect(() => {
    fetchObservations()
    
    // Poll for real-time updates
    const interval = setInterval(fetchObservations, pollInterval)
    return () => clearInterval(interval)
  }, [fetchObservations, pollInterval])

  return { observations, loading, error }
}
